import { ModificationFilterDto } from "app/ApiClient";
import { LoadingState } from "types";

export interface ModificationFiltersState {
  getLoading: LoadingState;
  updateLoading: LoadingState;
  errorMessage?: string;
  modificationFilters: ModificationFilterDto[];
  finishDateFilter: Nullable<ModificationFilterDto>;
}

export const initialModificationFiltersState: ModificationFiltersState = {
  getLoading: LoadingState.idle,
  updateLoading: LoadingState.idle,
  modificationFilters: [],
  finishDateFilter: null,
};
